export default __webpack_public_path__ + "static/media/image7.a4460443.webp";